import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ModalService } from '@purespectrum1/ui/modal';
import {
  EditCountryQuotaModalComponent,
  EditLocaleQuotaModalCloseResponse,
} from '../../../../../../shared/ui/edit-country-quota-modal/edit-country-quota-modal.component';
import {
  McSpvEachSurveyRequest,
  McSpvSurveyRequest,
  MultiCountrySpvSurvey,
} from '../../interface/multi-country.interface';
import {
  BuyerSurveyResponse,
  McSVPEachSurvey,
  Quotas,
  SurveyNoTargetingResponse,
} from '../../../../../../shared/interfaces/survey.interface';
import {
  CountryInterface,
  LanguageInterface,
} from '../../../../../../shared/interfaces/create-surveys.interface';
import { SURVEY_STATUS } from '../../../../../../shared/constants/survey-status';
import { LayoutConstants } from '../../../../../layout/layout-constants';
import { EMPTY, Observable, Subscription, of } from 'rxjs';
import { TableExpandableRowDirective } from '@purespectrum1/ui/table';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  skip,
  switchMap,
  tap,
} from 'rxjs/operators';
import { BuyerApiService } from '../../../../../../shared/services/buyer-api/survey.service';
import { MultiCountryDraftService } from '../../../../../services/multi-country-draft/multi-country-draft.service';
import { FeasibilityDataService as FeasibilityComponentService } from '../../../../../services/feasibility/feasibility-data.service';
import { QualificationsService } from '../../../../../services/qualification/qualifications.service';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { notifyMessage } from '../../../../../../shared/constants/notify-message';
import {
  MultiCountrySpvFeasibilitySurveyRequestMapper,
  MultiCountrySvpAddNewSurveyMapper,
} from '../../domain/multi-country-single-view-data-mapper';
import { Router } from '@angular/router';
import { MultiCountrySurveyFeasDataMapper } from '../../domain/multi-country-common-data-mapper';
import { MultiCountryService } from '../../services/multi-country.service';
import { ConfirmationModalComponent } from './../../../../../../shared/ui/confirmation-modal/confirmation-modal.component';
import { Constants } from './../../../../../../shared/constants/create-survey.constants';
import { McSvpSetterData } from '../../domain/mc-svp-survey-payload-composer';
import { isEqual } from '../../../../../../create-surveys/utils/deep-compare';
import { AuthService } from '../../../../../../shared/services/auth/auth.service';
import { ChangeSurveyStatusModalComponent } from '../../../../../../shared/ui/change-survey-status-modal/change-survey-status-modal.component';
import { Constants as DashboardConstants } from '../../../../../../shared/constants/dashboard-constants';
import { SurveyMetaDataService } from '../../../../../../shared/services/survey-meta-data/survey-meta-data.service';
import { EventEmitterService } from '../../../../../../shared/services/event-emitter/event-emitter.service';
import { MultiCountryFeasCpiData } from '../multi-country-draft.interface';
import { QuotaModalService } from '../../../../../../create-surveys/quota-modal/quota-modal.service';
@Component({
  selector: 'ps-ui-multi-country-single-project-view',
  templateUrl: './multi-country-single-project-view.component.html',
  styleUrls: ['./multi-country-single-project-view.component.css'],
})
export class MultiCountrySingleProjectViewComponent
  implements OnInit, OnChanges, OnDestroy
{
  constructor(
    private _modal: ModalService,
    private _toastr: ToasterService,
    private _buyerApiService: BuyerApiService,
    private _multiCountryDraftService: MultiCountryDraftService,
    private _multiCountryService: MultiCountryService,
    private _feasibilityComponentService: FeasibilityComponentService,
    private _qualificationService: QualificationsService,
    private _surveyMetaDataService: SurveyMetaDataService,
    private _router: Router,
    private _eventEmitterService: EventEmitterService,
    private _auth: AuthService,
    private _quotaModalService: QuotaModalService
  ) {}

  @ViewChild(TableExpandableRowDirective)
  public expandable!: TableExpandableRowDirective;

  @Input() multiCountrySpvParentSurvey = <BuyerSurveyResponse>{};
  @Input() multiCountrySpvChildSurveys: MultiCountrySpvSurvey[] = [];
  @Input() currentlySelectedSpvSurvey?: BuyerSurveyResponse;
  @Input() isCpiEditable = false;
  @Input() filteredCountries: CountryInterface[] = [];
  @Input() mcSvpPayload = <McSpvSurveyRequest>{};

  @Output() updateMcSpvChildSurveysData = new EventEmitter<
    MultiCountrySpvSurvey[]
  >();
  @Output() mcSurveyAdded = new EventEmitter();

  public selectedCountry = <CountryInterface>{};
  public selectedLanguage = <LanguageInterface>{};
  public isNotDraftSurvey: boolean = false;
  public isLaunchSurveyPage: boolean = false;

  private _addNewSpvSurvey$ = new EventEmitter<string>();
  private _subscriptions: Subscription = new Subscription();
  private _cpiValueChangeCommand$ = new EventEmitter<{
    cpi: number;
    index: number;
    survey_id: number;
  }>();
  private _cpiValueUpdateCommand$ = new EventEmitter<{
    cpi: number;
    survey: MultiCountrySpvSurvey;
  }>();
  private _completesUpdateCommand$ = new EventEmitter<{
    completes_required: number;
    survey: MultiCountrySpvSurvey;
  }>();
  private _childSurveySelectionCommand$ = new EventEmitter<{
    survey_id: number;
    updatePrevious: boolean;
  }>();
  private _childSurveyDeleteCommand$ =
    new EventEmitter<MultiCountrySpvSurvey>();
  private _shouldCallMcSvpFeasibilityFromFlyout: boolean = true;

  ngOnInit(): void {
    this._initiateStaticConfigs();
    this._handleMcSpvChildCpiFeasDataUpdates();
    this._handleCpiValueUpdates();
    this._handleCompleteValueUpdates();
    this._handleChildSurveySelection();
    this._handleNewSurveyCreation();
    this._handleMcFeasibilityCalls();
    this._handleAfterSaveSupplierAllocation();
    this._handleChildSurveyDeletion();
    this._handleMcSvpFeasibilityCallsAllowation();
    this.isNotDraftSurvey =
      this.multiCountrySpvParentSurvey.ps_survey_status !== SURVEY_STATUS.DRAFT;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.multiCountrySpvChildSurveys?.currentValue) {
      this._setMcQbOverrideValue();
    }
  }

  private _initiateStaticConfigs(): void {
    this.isLaunchSurveyPage = this._router.url.includes('launch-survey');
    this._setMcQbOverrideValue();
  }

  private _setMcQbOverrideValue() {
    const isMCQBPriceOverrideUndefinedForAllSurveys =
      this.multiCountrySpvChildSurveys.every((s) => !s.price_override);

    if (isMCQBPriceOverrideUndefinedForAllSurveys) {
      this._surveyMetaDataService.setMcQbOverrideValue(false);
      return;
    }
    const isMCQBPriceOverrideAppliedForAllSurveys =
      [
        ...new Set(
          this.multiCountrySpvChildSurveys?.map((s) => s.price_override)
        ),
      ].length === 1;
    this._surveyMetaDataService.setMcQbOverrideValue(
      isMCQBPriceOverrideAppliedForAllSurveys
    );
  }

  private _handleChildSurveySelection(): void {
    this._subscriptions.add(
      this._childSurveySelectionCommand$
        .pipe(
          filter(
            ({ survey_id: childSurveyId }) =>
              !this._shouldStopSurveySelectionProcess(childSurveyId)
          ),
          // Before switching to another locale, updating the data
          switchMap(({ survey_id: childSurveyId, updatePrevious }) => {
            if (!updatePrevious) {
              return of(childSurveyId);
            }

            return this._multiCountryService
              .updateSurvey(
                this.mcSvpPayload,
                this.multiCountrySpvParentSurvey.ps_survey_id
              )
              .pipe(
                catchError((err) => {
                  this._toastr.error(err.error.ps_api_response_message);
                  return of(null);
                }),
                filter((response) => !!response),
                map(() => childSurveyId)
              );
          })
        )
        .subscribe((childSurveyId) => {
          this._routeToTheSelectedSurvey(childSurveyId);
        })
    );
  }

  private _shouldStopSurveySelectionProcess(childSurveyId: number) {
    if (this.currentlySelectedSpvSurvey?.ps_survey_id === childSurveyId) {
      return true;
    }
    return false;
  }

  private _routeToTheSelectedSurvey(childId: number): void {
    this._multiCountryDraftService.setMcSpvSelectedChildId(childId);
  }

  public editCountryQuota() {
    const modalRef = this._modal.open(EditCountryQuotaModalComponent, {
      data: {
        multiCountrySurveyData: this.multiCountrySpvChildSurveys,
      },
      width: '80%',
    });
    modalRef.onClose$.subscribe(
      (response?: EditLocaleQuotaModalCloseResponse) => {
        if (response?.msg == 'ok') {
          const update: McSvpSetterData = {
            for: 'each',
            data: response.multiCountrySurveyData.map((childSurvey) => ({
              survey_localization: childSurvey.survey_localization,
              completes_required: childSurvey.completes_required,
              estimated_clicks: childSurvey.estimated_clicks,
            })),
          };
          this._multiCountryDraftService.sendMcSpvUpdateInCacheCommand(update);
          this._multiCountryDraftService.sendMcSpvGoalChangedCommand(
            response.totalCompletes
          );
        }
      }
    );
  }

  public selectCountry(country: CountryInterface) {
    this.selectedCountry = country;
    this.setLanguage(country.lang[0]);
  }

  public setLanguage(language: LanguageInterface) {
    this.selectedLanguage = language;
  }

  public onNewSurveyCreation(): void {
    const localization = `${this.selectedLanguage.transalte_code}_${this.selectedCountry.short_Code}`;
    this._addNewSpvSurvey$.next(localization);
  }

  private _handleNewSurveyCreation(): void {
    this._subscriptions.add(
      this._addNewSpvSurvey$
        .pipe(
          filter(
            () =>
              !!this.selectedLanguage.transalte_code &&
              !!this.selectedCountry.short_Code
          ),
          switchMap((localization) =>
            this._openConfirmationModal(localization)
          ),
          map((localization) =>
            new MultiCountrySvpAddNewSurveyMapper(
              this.mcSvpPayload,
              localization,
              this._auth.isLoggedInAsServiceBuyer()
            ).transform()
          ),
          tap((payload) => {
            this._multiCountryDraftService.sendMcSpvSurveyRequest(payload);
          }),
          switchMap((payload) =>
            this._multiCountryService
              .updateSurvey(
                payload,
                this.multiCountrySpvParentSurvey.ps_survey_id
              )
              .pipe(
                catchError((err) => {
                  this._toastr.error(err.error.ps_api_response_message);
                  return EMPTY;
                })
              )
          ),
          filter((response) => !!response),
          map((response) => response as SurveyNoTargetingResponse)
        )
        .subscribe((response) => {
          const { mc: { surveys = [] } = {} } = response;
          const newlyAddedSurveyId = this._fetchNewChildSurveyId(surveys);
          this.mcSurveyAdded.emit(response);
          this.selectedCountry = {} as CountryInterface;
          this.selectedLanguage = {} as LanguageInterface;
          this._childSurveySelectionCommand$.next({
            survey_id: newlyAddedSurveyId,
            updatePrevious: false,
          });
          this._toastr.success(
            notifyMessage.successMessage.NEW_COUNTRY_ADD_MCQB_CONFIRMATION
          );
        })
    );
  }

  private _fetchNewChildSurveyId(surveys: McSVPEachSurvey[]) {
    const newlyAddedSurvey = surveys.find(
      (survey: any) =>
        this._mapCountryCode(survey.countryCode) ===
          this.selectedCountry.short_Code &&
        survey.languageCode === this.selectedLanguage.transalte_code
    );
    return newlyAddedSurvey?.surveyId!;
  }

  private _mapCountryCode(countryCode: string): string {
    return countryCode === 'GB' ? 'UK' : countryCode;
  }

  private _openConfirmationModal(localization: string) {
    const modalRef = this._modal.open(ConfirmationModalComponent, {
      data: {
        text: Constants.CONFIRM_MODAL_TEXT
          .ADD_NEW_COUNTRY_IN_MCQB_CONFIRMATION_TEXT,
        confirmButtonLabel: 'Yes, add the new locale',
      },
    });
    return modalRef.onClose$.pipe(
      filter((op) => op === 'ok'),
      map(() => localization)
    );
  }

  public onSurveySelection(childSurvey: MultiCountrySpvSurvey) {
    this._childSurveySelectionCommand$.next({
      survey_id: childSurvey.survey_id,
      updatePrevious: true,
    });
  }

  private _updateMultiCountryData(
    surveyId: number,
    partial: Partial<MultiCountrySpvSurvey>
  ): void {
    this.multiCountrySpvChildSurveys = this.multiCountrySpvChildSurveys.map(
      (survey) => ({
        ...survey,
        ...(survey.survey_id === surveyId && partial),
      })
    );
  }

  private _handleMcSpvChildCpiFeasDataUpdates(): void {
    this._subscriptions.add(
      this._multiCountryDraftService
        .getMultiCountryFeasCpiData()
        .pipe(
          tap((cpiFeasData) =>
            this._updatePriceMultiplierInChildSurveys(cpiFeasData)
          ),
          map(
            (cpiFeasData) =>
              new MultiCountrySurveyFeasDataMapper(
                this.multiCountrySpvChildSurveys,
                cpiFeasData
              )
          ),
          filter((mapper) => !!mapper.find()),
          map((mapper) => mapper.transform())
        )
        .subscribe((mappedMcSurveys) => {
          this.updateMcSpvChildSurveysData.emit(mappedMcSurveys);
        })
    );
  }

  private _handleCpiValueUpdates(): void {
    this._subscriptions.add(
      this._cpiValueUpdateCommand$
        .pipe(
          filter((data) => {
            if (data.survey.state.cpi === 'not-confirmed') {
              this._toastr.error(notifyMessage.CPI_CONFIRMATION_ERROR);
              return false;
            }
            if (data.cpi === data.survey.cpi) {
              // do nothing if cpi is not changed
              this._updateMultiCountryData(data.survey.survey_id, {
                state: {
                  completes_required: 'view',
                  cpi: 'view',
                },
              });
              return false;
            }
            return true;
          }),
          switchMap((Surveydata) =>
            this._buyerApiService
              .updateOfferPriceOfSurvey(
                Surveydata.survey.survey_id,
                Surveydata.cpi
              )
              .pipe(map(() => Surveydata))
          )
        )
        .subscribe((data) => {
          this._updateCpiInParentPayload(
            data.survey.survey_localization,
            data.cpi
          );
          this._updateMultiCountryData(data.survey.survey_id, {
            cpi: data.cpi,
            price_override: data.cpi,
            state: {
              completes_required: 'view',
              cpi: 'view',
            },
          });
          this._multiCountryDraftService.setMultiCountryRunFeasibilityInfo({
            runFeasCalcForSurveys: [data.survey.survey_id],
            shouldSetFeasibilityFromFlyout: true,
          });
          const update = {
            offer_price: data.cpi,
          };
          this._updateMcSvpSurveyPayloadForLocale(
            data.survey.survey_localization,
            update
          );
          this._surveyMetaDataService.setMcQbOverrideValue(false);
        })
    );

    this._subscriptions.add(
      this._cpiValueChangeCommand$.pipe().subscribe((data) => {
        if (!this._isHighCpiValue(data.cpi)) {
          this.hideCpiConfirmationRow(data.index);
          this._updateMultiCountryData(data.survey_id, {
            state: { cpi: 'edit', completes_required: 'view' },
          });
          return;
        }

        this.showCpiConfirmationRow(data.index);
        this._updateMultiCountryData(data.survey_id, {
          state: { cpi: 'not-confirmed', completes_required: 'view' },
        });
      })
    );
  }

  private _handleCompleteValueUpdates(): void {
    this._subscriptions.add(
      this._completesUpdateCommand$.subscribe(
        ({ completes_required, survey }) => {
          if (this._hasEmptyAllocation(completes_required)) {
            this._toastr.error(
              notifyMessage.errorMessage.COMPLETES_REQUIRED.CANNOT_BE_ZERO
            );
            return;
          }
          this._updateMultiCountryData(survey.survey_id, {
            completes_required,
            state: {
              cpi: survey.state.cpi,
              completes_required: 'view',
            },
          });
          this._updateMcSvpSurveyPayloadForLocale(survey.survey_localization, {
            completes_required,
            estimated_clicks: Math.round(
              (completes_required * 100) / survey.expected_ir
            ),
            quotas: this._distributeQuotaPayloadOnCompleteChange(
              survey.survey_localization,
              completes_required
            ),
          });
        }
      )
    );
  }

  private _hasEmptyAllocation(completes: number): boolean {
    return !completes;
  }

  private _updateMcSvpSurveyPayloadForLocale(
    localization: string,
    update: Partial<Omit<BuyerSurveyResponse, 'survey_localization'>>
  ) {
    const data: McSvpSetterData = {
      for: 'each',
      data: [
        {
          survey_localization: localization,
          ...update,
        },
      ],
    };
    this._multiCountryDraftService.sendMcSpvUpdateInCacheCommand(data);
  }

  private _updatePriceMultiplierInChildSurveys(
    feasCpiData: MultiCountryFeasCpiData
  ) {
    const child = this.multiCountrySpvChildSurveys.find(
      (child) => Number(child.survey_id) === feasCpiData.surveyId
    );
    if (!child) {
      return;
    }
    const update = {
      pricing_multiplier: feasCpiData.pricing_multiplier,
    };
    this._updateMcSvpSurveyPayloadForLocale(child.survey_localization, update);
  }

  private _updateCpiInParentPayload(surveyLocalization: string, cpi: number) {
    this.mcSvpPayload.surveys.forEach((survey) => {
      if (survey.survey_localization === surveyLocalization) {
        survey.offer_price = cpi;
      }
    });
  }

  private _isHighCpiValue(cpi: number): boolean {
    if (cpi > Number(LayoutConstants.MAX_CPI_THRESHOLD)) {
      return true;
    }
    return false;
  }

  public showCpiConfirmationRow(index: number): void {
    this.expandable?.expand(index);
  }

  public hideCpiConfirmationRow(index: number): void {
    this.expandable?.retract(index);
  }

  public onCpiValueChange(
    cpi: string,
    survey: MultiCountrySpvSurvey,
    index: number
  ) {
    this._cpiValueChangeCommand$.next({
      cpi: Number(cpi),
      index,
      survey_id: survey.survey_id,
    });
  }

  public onCpiValueUpdate(cpi: string, survey: MultiCountrySpvSurvey): void {
    this._cpiValueUpdateCommand$.next({ cpi: Number(cpi), survey });
  }

  public onCpiConfirmation(survey: MultiCountrySpvSurvey, index: number): void {
    this._updateMultiCountryData(survey.survey_id, {
      state: { cpi: 'edit', completes_required: 'view' },
    });
    this.hideCpiConfirmationRow(index);
  }

  public onCompletesUpdate(
    completes: string,
    survey: MultiCountrySpvSurvey
  ): void {
    this._completesUpdateCommand$.next({
      completes_required: Number(completes),
      survey,
    });
  }

  private _handleChildSurveyDeletion(): void {
    this._subscriptions.add(
      this._childSurveyDeleteCommand$
        .pipe(
          filter(() => {
            if (this._hasLastTwoChildrenRemaining()) {
              this._toastr.error(
                notifyMessage.errorMessage.MC_SINGLE_VIEW
                  .DELETING_LAST_TWO_CHILDREN_NOT_ALLOWED
              );
              return false;
            }
            return true;
          }),
          switchMap((childSurvey) => this._confirmAndDeleteMcSvp(childSurvey))
        )
        .subscribe((deletedSurvey) => {
          const formerIndex = this._findFormerIndex(deletedSurvey.survey_id);
          this._removeDeleteChildFromList(deletedSurvey);
          const newIndex = this._findIndexOfChildToSelect(formerIndex);
          this._childSurveySelectionCommand$.next({
            survey_id: this.multiCountrySpvChildSurveys[newIndex].survey_id,
            updatePrevious: false,
          });
          this._toastr.success(
            notifyMessage.successMessage.MULTICOUNTRY_SINGLE_VIEW
              .DELETED_SUCCESSFULLY
          );
        })
    );
  }

  private _hasLastTwoChildrenRemaining(): boolean {
    return this.multiCountrySpvChildSurveys.length <= 2;
  }

  private _confirmAndDeleteMcSvp(
    childSurvey: MultiCountrySpvSurvey
  ): Observable<MultiCountrySpvSurvey> {
    return of(childSurvey.survey_id).pipe(
      map((surveyId) => ({
        surveyId,
        toDelete: true,
        isMcSvpChild: true,
      })),
      map((data) =>
        this._modal.open(ChangeSurveyStatusModalComponent, {
          data,
          width: '500px',
          height: '21rem',
        })
      ),
      switchMap((ref) => ref.onClose$),
      filter((msg) => msg === DashboardConstants.MODAL_MESSAGE.DELETE_SURVEY),
      map(() => childSurvey)
    );
  }

  private _findFormerIndex(deletedChildSurveyId: number): number {
    return this.multiCountrySpvChildSurveys.findIndex(
      (childSurvey) => childSurvey.survey_id === deletedChildSurveyId
    );
  }

  private _removeDeleteChildFromList(
    deletedChild: MultiCountrySpvSurvey
  ): void {
    // Removing it for the component in case subscription based update via composer gets delayed
    this.mcSvpPayload = {
      ...this.mcSvpPayload,
      survey_localizations: this.mcSvpPayload.survey_localizations.filter(
        (localization) => localization !== deletedChild.survey_localization
      ),
      surveys: this.mcSvpPayload.surveys.filter(
        (s) => s.survey_id !== deletedChild.survey_id
      ),
    };

    // Delete it from the composer data as well
    this._multiCountryDraftService.sendMcSpvRemoveFromCache({
      data: [deletedChild.survey_localization],
    });

    // Remove the child from the flyout table
    this.multiCountrySpvChildSurveys = this.multiCountrySpvChildSurveys.filter(
      (mcSurvey) => mcSurvey.survey_id !== deletedChild.survey_id
    );
    this.updateMcSpvChildSurveysData.emit(this.multiCountrySpvChildSurveys);
  }

  private _findIndexOfChildToSelect(formerIndex: number): number {
    return formerIndex > this.multiCountrySpvChildSurveys.length - 1
      ? 0
      : formerIndex;
  }

  public onChildSurveyDelete(survey: MultiCountrySpvSurvey) {
    this._childSurveyDeleteCommand$.next(survey);
  }

  private _handleMcFeasibilityCalls() {
    this._subscriptions.add(
      this._multiCountryDraftService
        .getMcSpvSurveyRequest()
        .pipe(
          filter((data) => !!data.surveys?.length),
          filter(() => this._shouldCallMcSvpFeasibilityFromFlyout),
          map((data) =>
            new MultiCountrySpvFeasibilitySurveyRequestMapper(
              data.surveys
            ).transform()
          ),
          distinctUntilChanged((previous, current) =>
            isEqual(previous, current)
          ),
          debounceTime(1000)
        )
        .subscribe((surveys) => {
          this._setFeasibilityPostDraftSave(surveys);
        })
    );
  }

  private _setFeasibilityPostDraftSave(mcSurveys: McSpvEachSurveyRequest[]) {
    mcSurveys.forEach((mcSurvey) => {
      if (mcSurvey.survey_id) {
        const [surveyId, language, surveyRequest, qualifications] =
          this._buildPayloadForSetFeasibility(mcSurvey);
        this._feasibilityComponentService.setFeasibility(
          surveyId,
          language,
          surveyRequest,
          qualifications,
          true,
          surveyId == this.currentlySelectedSpvSurvey?.ps_survey_id
        );
      }
    });
  }

  private _buildPayloadForSetFeasibility(mcSurvey: McSpvEachSurveyRequest) {
    const surveyId = Number(mcSurvey.survey_id);
    const language = mcSurvey.language_short_code;
    const qualifications = this._qualificationService.getQualifications();
    return [surveyId, language, mcSurvey, qualifications];
  }

  private _handleAfterSaveSupplierAllocation() {
    this._multiCountryDraftService
      .getAfterSaveAllocationMcSpvChildId()
      .pipe(skip(1))
      .subscribe((childId) => {
        this.onSurveySelection({ survey_id: childId } as MultiCountrySpvSurvey);
      });
  }

  private _handleMcSvpFeasibilityCallsAllowation() {
    this._subscriptions.add(
      this._multiCountryDraftService
        .getShouldCallMcSvpFeasibilityFromFlyout()
        .subscribe((value) => {
          this._shouldCallMcSvpFeasibilityFromFlyout = value;
        })
    );
  }

  private _distributeQuotaPayloadOnCompleteChange(
    surveyLocalization: string,
    completes_required: number
  ): Quotas[] {
    const survey: McSpvEachSurveyRequest = this.mcSvpPayload.surveys.find(
      (childSurvey) => childSurvey.survey_localization === surveyLocalization
    )!;
    if (survey?.quotas?.length) {
      survey.completes_required = completes_required;

      const childSurvey =
        this._quotaModalService.redistributeQuotasForSpvSurvey(
          survey as BuyerSurveyResponse,
          !!survey.click_balancing
        );
      return childSurvey.quotas;
    }
    return [];
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
